import { localStorageAvailable } from './localStorage';

const acpfNudgeHelper = (
  name,
  goalSlug,
  goalUID,
  subscriptionUID,
  isCombo,
  type,
  comboUID
) => {
  if (localStorageAvailable()) {
    let acpfStorage = localStorage.getItem('acpf');
    acpfStorage = acpfStorage ? JSON.parse(acpfStorage) : {};
    delete acpfStorage[goalUID];
    acpfStorage[goalUID] = {
      date: new Date(),
      name,
      goalSlug,
      subscriptionUID,
      isCombo,
      type,
      comboUID
    };
    localStorage.setItem('acpf', JSON.stringify(acpfStorage));
  }
};

export const getAcpfStorage = (goalUID) => {
  if (localStorageAvailable()) {
    let acpfStorage = localStorage.getItem('acpf');
    if (acpfStorage) {
      acpfStorage = JSON.parse(acpfStorage);
      if (acpfStorage[goalUID]) {
        const diffTime = Math.abs(
          new Date() - new Date(acpfStorage[goalUID].date)
        );
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays <= 3) {
          return acpfStorage[goalUID];
        }
        // 3 days old check
        delete acpfStorage[goalUID];
        localStorage.setItem('acpf', JSON.stringify(acpfStorage));
      }
    }
  }
};

export const deleteGoalFromAcpf = (goalUID) => {
  if (localStorageAvailable()) {
    let acpfStorage = localStorage.getItem('acpf');
    if (acpfStorage) {
      acpfStorage = JSON.parse(acpfStorage);
      delete acpfStorage[goalUID];
      localStorage.setItem('acpf', JSON.stringify(acpfStorage));
    }
  }
};

export default acpfNudgeHelper;
